<div>
  @if (nodes(); as nodes) {
    <div class="header-search position-relative search-box mb-2">
      <input
        type="text"
        [placeholder]="placeholderText() | translate"
        [(ngModel)]="filterText"
        (ngModelChange)="onFilterChange()"
        class="form-control"
        aria-label="Search nodes" />
    </div>
    <div
      [ngStyle]="maxHeightStyle() ? { 'max-height': maxHeightStyle(), 'overflow-y': 'auto' } : {}"
      aria-label="Treeview container">
      <nk-treeview-node [andClass]="'ms-0'" [nodes]="treeNodes()" aria-label="Treeview node list"></nk-treeview-node>
    </div>
  } @else {
    <span aria-label="No data available">{{ noDataText() | translate }}</span>
  }
</div>
